var _uploadtools = this;

this.handleFileUpload = (files, component) => {
    this._component = component;
    component.isLoading = true;
    for (var i = 0; i < files.length; i++) {
            var fd = new FormData();
            fd.append('file', files[i]);
            this.fireBaseImageUpload({
                'file': files[i],
                'path': component.folder, //path_to_where_you_to_store_the_file,
                'file-name': component.fileName
            }, function (data) {
              if (!data.error) {
                  if (data.progress) {
                      // progress update to view here
                  }
                  if (data.downloadURL) {
                      _uploadtools._component.$emit("upload", data.downloadURL)
                      // update done
                      // download URL here "data.downloadURL"
                  }
              } else {
                  console.log(data.error);
                  console.log(data.error + ' Firebase image upload error');
              }
          });
    }
}

this.handleSingleFileUpload = (file, component) => {
    this._component = component;
    component.isLoading = true;
    var fd = new FormData();
    fd.append('file', file);
    this.fireBaseImageUpload({
        'file': file,
        'path': component.folder, //path_to_where_you_to_store_the_file,
        'file-name': component.fileName
    }, function (data) {
      if (!data.error) {
          if (data.progress) {
              // progress update to view here
          }
          if (data.downloadURL) {
              _uploadtools._component.$emit("upload", data.downloadURL)
              // update done
              // download URL here "data.downloadURL"
          }
      } else {
          console.log(data.error);
          console.log(data.error + ' Firebase image upload error');
      }
  });
}

this.handleSingleNamedFileUpload = (file, folder, name, ref) => {
    var fd = new FormData();
    fd.append('file', file);
    this.fireBaseImageUpload({
        'file': file,
        'path': folder, //path_to_where_you_to_store_the_file,
        'file-name': name
    }, function (data) {
      if (!data.error) {
          if (data.progress) {
              // progress update to view here
          }
          if (data.downloadURL) {
              ref.set(data.downloadURL);
              // update done
              // download URL here "data.downloadURL"
          }
      } else {
          console.log(data.error);
          console.log(data.error + ' Firebase image upload error');
      }
  });
}

this.fireBaseImageUpload = (parameters, callBackData) => {

    // expected parameters to start storage upload
    var file = parameters.file;
    var path = parameters.path;
    var name = parameters['file-name'] + ".png";
    //just some error check
    if (!file) { callBackData({error: 'file required to interact with Firebase storage'}); }
    if (!path) { callBackData({error: 'Node name required to interact with Firebase storage'}); }

    var metadata = {'contentType': file.type};
    var arr = file.name.split('.');
    var fileSize = this.formatBytes(file.size); // get clean file size (function below)
    var fileType = file.type;
    var n = file.name;

    // generate random string to identify each upload instance
    // name = generateRandomString(12); //(location function below)

    //var fullPath = path + '/' + name + '.' + arr.slice(-1)[0];
    var fullPath = path + '/' + name;
    var storageRef = firebase.storage().ref();
    var uploadFile = storageRef.child(fullPath).put(file, metadata);

    // first instance identifier
    callBackData({id: name, fileSize: fileSize, fileType: fileType, fileName: n});

    uploadFile.on('state_changed', function (snapshot) {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        progress = Math.floor(progress);
        callBackData({
            progress: progress,
            element: name,
            fileSize: fileSize,
            fileType: fileType,
            fileName: n});
    }, function (error) {
        callBackData({error: error});
    }, function () {
        var downloadURL = uploadFile.snapshot.downloadURL;
        callBackData({
            downloadURL: downloadURL,
            element: name,
            fileSize: fileSize,
            fileType: fileType,
            fileName: n});
    });
}

this.generateRandomString = (length) => {
    var chars = "abcdefghijklmnopqrstuvwxyz";
    var pass = "";
    for (var x = 0; x < length; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
    }
    return pass;
}

this.formatBytes = (bytes, decimals) => {
    if (bytes == 0) return '0 Byte';
    var k = 1000;
    var dm = decimals + 1 || 3;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export default{
  name: 'UploadTools',
  handleFileUpload: this.handleFileUpload,
  handleSingleFileUpload: this.handleSingleFileUpload,
  handleSingleNamedFileUpload: this.handleSingleNamedFileUpload
}


// WEBPACK FOOTER //
// ./C:/Git/adventify-vuefire/src/components/UploadTools.js